import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const MobileIcon = ({ size, deg, color, }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", size: size, deg: deg },
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: color, transform: "translate(5 2)" },
        React.createElement("rect", { width: "9.467", height: "14.8", x: ".6", y: ".6", strokeWidth: "1.2", rx: "3" }),
        React.createElement("path", { d: "M.762 2.286h9.143M.762 12.19h9.143" }),
        React.createElement("path", { strokeLinecap: "round", d: "M4.571 13.778h1.331" }))));
export const Mobile = iconGenerator(MobileIcon);
//# sourceMappingURL=Mobile.js.map